var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "#0c1c8c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fc0"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 8.823,
    y: -8.676
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.397 10.677l.33 1.011h1.067l-.863.625.33 1.011-.864-.625-.863.625.33-1.011L2 11.687h1.067l.33-1.011z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 4.412,
    y: -16.324
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 4.412,
    y: -1.176
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: 7.647,
    y: 13.088
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#D",
    y: -15.148
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: 7.647,
    y: -13.088
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    x: -7.5,
    y: 13.088
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C",
    x: -7.5,
    y: -13.088
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M12.074 2l.33.955h1.067l-.863.59.33.955-.864-.59-.863.59.33-.955-.863-.59h1.067l.33-.955z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M12.074 19.353l.33 1.011h1.067l-.863.625.33 1.011-.864-.625-.863.625.33-1.011-.863-.625h1.067l.33-1.011z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "M7.735 18.177l.312 1.011h1.011l-.818.625.312 1.011-.818-.625-.818.625.312-1.011-.818-.625h1.011l.313-1.011z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/eur.3eb3cc864faf22fd780801dce2b3addb.svg";
export { ForwardRef as ReactComponent };